/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Pedal_Action_Fast_ForwardInputs */



/**
* | output |
* | --- |
* | "Fast Forward" |
*
* @param {Options_Pedal_Action_Fast_ForwardInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_pedal_action_fast_forward = /** @type {((inputs?: Options_Pedal_Action_Fast_ForwardInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Pedal_Action_Fast_ForwardInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Avance rapide")
	if (locale === "de") return /** @type {LocalizedString} */ ("Schnellvorlauf")
	if (locale === "it") return /** @type {LocalizedString} */ ("Avanti veloce")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Перемотка вперед")
	if (locale === "es") return /** @type {LocalizedString} */ ("Avance rápido")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("快进")
	if (locale === "ja") return /** @type {LocalizedString} */ ("早送り")
	if (locale === "hi") return /** @type {LocalizedString} */ ("तेजी से आगे बढ़ना")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Avanço rápido")
	return /** @type {LocalizedString} */ ("Fast Forward")
});